<template>
  <div v-if="!examInfo" id="manageClass">
    <div class="allBodyDiv">
      <div style="margin-top: 15px; overflow: hidden; z-index: 100"></div>

      <el-row class="manageClassBody" :gutter="20">
        <el-col :span="24" class="leftMember">
          <el-card class="box-card listCard2">
            <div
              slot="header"
              class="clearfix"
              style="height: 34px; line-height: 34px"
            >
              <el-radio-group v-model="testType" @change="getList">
                <el-radio-button :label="3"
                  >&nbsp;&nbsp;&nbsp;全部&nbsp;&nbsp;&nbsp;</el-radio-button
                >
                <el-radio-button :label="1">正在进行</el-radio-button>
                <el-radio-button :label="2"
                  >&nbsp;&nbsp;已结束&nbsp;&nbsp;</el-radio-button
                >
              </el-radio-group>

              <span style="float: right; font-size: 14px"
                >提交次数：{{ pushNum }}次</span
              >
            </div>
            <div v-for="i in tableData3" :key="i.id">
              <div
                v-if="i.examination.isBegin == 1 || i.examination.isBegin == 0"
                class="testReleaseList"
              >
                <div class="listHeader">
                  <span class="listHeader-title">{{ i.examination.name }}</span>
                  <span class="listHeader-time"
                    >开始时间：{{ i.examination.start_time }}</span
                  >
                  <span class="listHeader-time"
                    >结束时间：{{ i.examination.end_time }}</span
                  >
                  <span class="fr listHeader-overTime"
                    >距离结束：{{ i.endTime }}</span
                  >
                </div>
                <div class="listBody">
                  <el-table
                    :show-header="false"
                    :data="i.examination_experiment"
                    border
                    highlight-current-row
                    row-class-name="graspTr"
                    header-row-class-name="graspHeader"
                    style="width: 100%"
                  >
                    <el-table-column prop="name" width="355" label="实验名">
                    </el-table-column>
                    <el-table-column prop="avg_score" label="">
                    </el-table-column>
                    <el-table-column label="">
                      <template slot-scope="props">
                        <span>排名：</span>
                        <span>{{
                          props.row.rank ? props.row.rank : "无"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="170" label="操作">
                      <template slot-scope="props">
                        <div v-if="i.examination.isBegin == 1">
                          <a v-if="props.row.examInfo.state == 0">
                            <el-button
                              @click="goExam(i.examination, props.row)"
                              class="nbBtn nbBtn2"
                              style="background-color: #2f87ff; color: #fff"
                              size="small"
                            >
                              去完成
                            </el-button>
                          </a>
                          <el-button
                            v-else
                            @click="
                              $router.push({
                                path: '/studentexamdetails',
                                query: {
                                  plan: props.row.examInfo.exerciseId,
                                  name: props.row.name,
                                  title: i.examination.name,
                                },
                              })
                            "
                            class="nbBtn nbBtn2"
                            size="small"
                          >
                            查看详情
                          </el-button>
                        </div>
                        <el-button
                          v-else
                          class="nbBtn nbBtn2"
                          disabled
                          style="background-color: #2f87ff; color: #fff"
                          size="small"
                        >
                          尚未开始
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div v-else class="Unpublished">
                <div class="listHeader">
                  <span class="listHeader-title">{{ i.examination.name }}</span>
                  <span class="listHeader-time"
                    >发布时间：{{ i.examination.add_time }}</span
                  >
                  <span class="listHeader-time"
                    >开始时间：{{ i.examination.start_time }}</span
                  >
                  <span class="listHeader-overTime">已结束</span>
                </div>
                <div class="listBody">
                  <el-table
                    :show-header="false"
                    :data="i.examination_experiment"
                    border
                    highlight-current-row
                    row-class-name="graspTr"
                    header-row-class-name="graspHeader"
                    style="width: 100%"
                  >
                    <el-table-column prop="name" width="355" label="实验名">
                    </el-table-column>
                    <el-table-column prop="avg_score" label="">
                    </el-table-column>
                    <el-table-column label="">
                      <template slot-scope="props">
                        <span>排名：</span>
                        <span>{{
                          props.row.rank ? props.row.rank : "无"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="170" label="操作">
                      <template slot-scope="props">
                        <span
                          v-if="
                            props.row.exam_status == 0 && props.row.status == 2
                          "
                        >
                          缺考
                        </span>

                        <el-button
                          v-else
                          @click="
                            $router.push({
                              path: '/studentexamdetails',
                              query: {
                                plan: props.row.examInfo.exerciseId,
                                name: props.row.name,
                                title: i.examination.name,
                              },
                            })
                          "
                          class="nbBtn nbBtn2"
                          size="small"
                        >
                          查看详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>

            <div
              v-if="filters.total > 0"
              style="margin-top: 30px; text-align: right"
            >
              <el-pagination
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="currentPage4"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="filters.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="filters.total"
              >
              </el-pagination>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
  <entexam v-else ref="toexam" @goBack="goExamBack"></entexam>
</template>
<script>
import { Loading } from 'element-ui';
import {
  getpushlist,
  getexamrecord,
  getclasslist,
  pushexam,
} from "./../../api/exam_api";
import entExam from "./entExam.vue";
export default {
  components: {
    entexam: entExam,
  },
  data() {
    return {
      examInfo: false,
      releaseUndo: false,
      tableData3: [],
      filters: {
        pageSize: 5,
        total: 0,
        page: 1,
      },
      currentPage4: 1,
      releaseTest: false,
      releaseTest2: false,
      textNum: 0,
      releaseForm: {
        checkedTest: [],
        name: "",
        time: "",
        checkClass: [],
      },
      testList: [],
      rulesRelease: {
        name: [
          {
            required: true,
            min: 2,
            max: 15,
            message: "请输入2到15位考试名称",
            trigger: "blur",
          },
        ],
        time: [{ required: true, message: "请选择起止时间", trigger: "blur" }],
        checkClass: [
          { required: true, message: "请选择班级", trigger: "blur" },
        ],
      },
      classData: [],
      timeArrray: [],
      classSelected: "",
      releaseArray: [],
      releaseLoading: false,
      classList: [],
      testType: 3,
      pushNum: 0,
    };
  },
  methods: {
    goExamBack() {
      this.examInfo = false;
      this.getList();
    },
    pageSizeChange(val) {
      this.filters.pageSize = val;
      this.getList();
    },
    pageChange(val) {
      this.filters.page = val;
      this.getList();
    },
    getList() {
      let loadingInstance = Loading.service({
        target: "#nbBody"
      });
      let data = {
        page: this.filters.page,
        perPage: this.filters.pageSize,
        state: this.testType,
        productid: this.GLOBAL.productId,
      };
      getexamrecord(data).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.tableData3 = res.data.list.data;
          this.pushNum = res.data.subNum;
          this.filters.total = res.data.list.total;
          let that = this;
          this.tableData3.forEach(function (index, i) {
            index.examination.add_time = that.GLOBAL.request.toTime(
              index.examination.addTime * 1000,
              1
            );
            index.examination.start_time = that.GLOBAL.request.toTime(
              index.examination.beginTime * 1000,
              1
            );
            index.examination.end_time = that.GLOBAL.request.toTime(
              index.examination.endTime * 1000,
              1
            );
            if (
              index.examination.isStatistics == 1 ||
              index.examination.isStatistics == 0
            ) {
              let oDate2 = index.examination.endTime * 1000;
              let oDate1 = new Date();
              let nTime = oDate2 - oDate1.getTime();
              let day = Math.floor(nTime / 86400000);
              let hour = Math.floor((nTime % 86400000) / 3600000);
              let minute = Math.floor(((nTime % 86400000) % 3600000) / 60000);
              let _time = day + "天 " + hour + "小时 " + minute + "分";
              index.endTime = _time;
            }
            let _num = i;
            let examArray = index.examination_experiment;
            for (let a = 0; a < examArray.length; a++) {
              let index2 = examArray[a];
              // debugger;
              if (!index2.examInfo) {
                that.tableData3[_num].examination_experiment.splice(a, 1);
                a -= 1;
              } else {
                index2.avg_score = index2.examInfo.score
                  ? "得分：" + index2.examInfo.score
                  : "得分：暂无";
              }
              index2.ratioHalf =
                index2.sub_num <= 0
                  ? 0
                  : Math.round((index.sub_num / index2.studentNum) * 10000) /
                    100.0;
            }
          });
          that.tableData3;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        loadingInstance.close();
      });
    },
    goExam($id, $data) {
      // debugger;
      if ($id.endTime * 1000 < Date.now()) {
        this.$message("考试已结束，请刷新页面");
        return;
      }
      this.examInfo = true;
      let that = this;
      $data.id = $id.id;
      $data.exam_name = $id.name;
      $data.subjectid = this.GLOBAL.subjectId;
      setTimeout(() => {
        that.$refs.toexam.examClick($data, 3);
      }, 100);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/StudentExanCentre.vue